import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Telephone = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 22">
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.864 5.1309L12.7335 9.06715L8.67106 13.9658L5.13974 13.7931L1.45927 16.9169C0.964449 17.3369 0.994594 18.1097 1.52063 18.4898L4.22906 20.4472C4.56874 20.6926 5.02545 20.7003 5.37314 20.4663L9.99192 17.3577L16.8091 9.69118L18.5762 4.59198C18.7047 4.22101 18.6043 3.80914 18.3194 3.53897L15.81 1.15906C15.3541 0.726629 14.617 0.816957 14.2789 1.34669L11.864 5.1309Z"
        stroke="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default Telephone;
